(function () {
  'use strict';

  var DEBOUNCE = 280;
  var MIN_CHARS = 2;

  function init() {
    var input = document.getElementById('ps-cs-input');
    var dropdown = document.getElementById('ps-cs-dropdown');
    var clearBtn = document.getElementById('ps-cs-clear');
    if (!input || !dropdown) return;

    var timer = null;
    var activeIndex = -1;
    var currentResults = [];

    // ── Input handler ──────────────────────────────────────────────
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearBtn.style.display = q.length ? 'flex' : 'none';
      filterCards(q);
      clearTimeout(timer);
      if (q.length < MIN_CHARS) { closeDropdown(); return; }
      timer = setTimeout(function () { fetchSuggestions(q); }, DEBOUNCE);
    });

    // ── Clear button ───────────────────────────────────────────────
    clearBtn.addEventListener('click', function () {
      input.value = '';
      clearBtn.style.display = 'none';
      filterCards('');
      closeDropdown();
      input.focus();
    });

    // ── Keyboard navigation ────────────────────────────────────────
    input.addEventListener('keydown', function (e) {
      var items = dropdown.querySelectorAll('.ps-cs__item[data-url]');
      if (!items.length) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeIndex = Math.min(activeIndex + 1, items.length - 1);
        setActive(items);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex = Math.max(activeIndex - 1, -1);
        setActive(items);
      } else if (e.key === 'Enter') {
        if (activeIndex >= 0 && items[activeIndex]) {
          e.preventDefault();
          window.location.href = items[activeIndex].dataset.url;
        } else {
          e.preventDefault();
          window.location.href = '/search?q=' + encodeURIComponent(input.value.trim()) + '&type=product';
        }
      } else if (e.key === 'Escape') {
        closeDropdown();
        input.blur();
      }
    });

    // ── Close on outside click ─────────────────────────────────────
    document.addEventListener('click', function (e) {
      if (!e.target.closest('#ps-cs-wrap')) closeDropdown();
    });

    // ── Fetch from Shopify Predictive Search API ───────────────────
    function fetchSuggestions(q) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=7&resources[options][unavailable_products]=last';
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderDropdown(q, products);
        })
        .catch(function () { closeDropdown(); });
    }

    // ── Render dropdown ────────────────────────────────────────────
    function renderDropdown(q, products) {
      activeIndex = -1;
      if (!products.length) {
        dropdown.innerHTML = '<div class="ps-cs__empty">No products found for "<strong>' + escHtml(q) + '</strong>"</div>';
        dropdown.classList.add('is-open');
        return;
      }
      var html = '';
      products.forEach(function (p) {
        var img = p.image ? '<img src="' + p.image + '" alt="' + escHtml(p.title) + '" loading="lazy">' : '<div class="ps-cs__no-img"></div>';
        var price = p.price ? '<span class="ps-cs__price">' + p.price + '</span>' : '';
        var vendor = p.vendor ? '<span class="ps-cs__vendor">' + escHtml(p.vendor) + '</span>' : '';
        html += '<a class="ps-cs__item" href="' + p.url + '" data-url="' + p.url + '">' +
          '<div class="ps-cs__thumb">' + img + '</div>' +
          '<div class="ps-cs__info">' +
            '<span class="ps-cs__title">' + highlight(escHtml(p.title), q) + '</span>' +
            '<div class="ps-cs__meta">' + vendor + price + '</div>' +
          '</div>' +
        '</a>';
      });
      html += '<a class="ps-cs__view-all" href="/search?q=' + encodeURIComponent(q) + '&type=product">View all results for "<strong>' + escHtml(q) + '</strong>" &rarr;</a>';
      dropdown.innerHTML = html;
      dropdown.classList.add('is-open');
    }

    function setActive(items) {
      items.forEach(function (el, i) { el.classList.toggle('is-active', i === activeIndex); });
    }

    function closeDropdown() {
      dropdown.classList.remove('is-open');
      dropdown.innerHTML = '';
      activeIndex = -1;
    }

    // ── Client-side card filtering ─────────────────────────────────
    function filterCards(q) {
      var cards = document.querySelectorAll('#product-grid .grid__item');
      if (!q) {
        cards.forEach(function (c) { c.style.display = ''; });
        showNoMatchMsg(false);
        return;
      }
      var ql = q.toLowerCase();
      var visible = 0;
      cards.forEach(function (c) {
        var title = (c.querySelector('.card__heading') || c.querySelector('[class*="heading"]') || c);
        var text = title.textContent.toLowerCase();
        var match = text.indexOf(ql) !== -1;
        c.style.display = match ? '' : 'none';
        if (match) visible++;
      });
      showNoMatchMsg(visible === 0);
    }

    function showNoMatchMsg(show) {
      var msg = document.getElementById('ps-cs-no-match');
      if (msg) msg.style.display = show ? 'block' : 'none';
    }

    // ── Helpers ────────────────────────────────────────────────────
    function escHtml(str) {
      return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    }
    function highlight(str, q) {
      var re = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
      return str.replace(re, '<mark>$1</mark>');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
